module.exports = __webpack_public_path__ + "static/media/transactions.e61b7159.mp4";